const account_center = {
    home: {
        title: 'Сторінку не знайдено',
        description: 'Ця сторінка недоступна.',
    },
    page: {
        title: 'Акаунт',
        security_title: 'Безпека',
        security_description: 'Тут можна змінити налаштування акаунта, щоб забезпечити його безпеку.',
        profile_title: 'Особиста інформація',
        profile_description: 'Змініть свою особисту інформацію тут.',
        sidebar_personal_info: 'Особиста інформація',
        sidebar_security: 'Безпека',
        sidebar_sessions: 'Сесії',
        support: 'Підтримка',
    },
    verification: {
        title: 'Перевірка безпеки',
        description: 'Підтвердьте, що це ви, щоб захистити безпеку облікового запису. Будь ласка, оберіть спосіб підтвердження особи.',
        error_send_failed: 'Не вдалося надіслати код підтвердження. Спробуйте ще раз пізніше.',
        error_invalid_code: 'Код підтвердження недійсний або строк його дії минув.',
        error_verify_failed: 'Не вдалося підтвердити. Будь ласка, введіть код ще раз.',
        verification_required: 'Термін перевірки минув. Підтвердіть свою особу ще раз.',
        try_another_method: 'Спробуйте інший спосіб підтвердження',
        no_available_methods_title: 'Немає доступних способів підтвердження',
        no_available_methods_description: 'У вас не налаштовано жодного способу підтвердження. Спочатку додайте до свого облікового запису пароль, email або номер телефону.',
    },
    password_verification: {
        title: 'Підтвердьте пароль',
        description: 'Щоб захистити обліковий запис, введіть пароль для підтвердження своєї особи.',
        error_failed: 'Невірний пароль. Перевірте введені дані.',
    },
    verification_method: {
        password: {
            name: 'Пароль',
            description: 'Підтвердьте свій пароль',
        },
        email: {
            name: 'Код підтвердження електронної пошти',
            description: 'Надіслати код підтвердження на вашу пошту',
        },
        phone: {
            name: 'Код підтвердження телефону',
            description: 'Надіслати код підтвердження на ваш номер телефону',
        },
    },
    email: {
        title: "Прив'язати email",
        description: "Прив'яжіть свій email, щоб входити або допомогти з відновленням облікового запису.",
        verification_title: 'Введіть код підтвердження email',
        verification_description: 'Код підтвердження надіслано на ваш email {{email_address}}.',
        success: "Основний email успішно прив'язано.",
        verification_required: 'Термін перевірки минув. Підтвердіть свою особу ще раз.',
    },
    phone: {
        title: "Прив'язати телефон",
        description: "Прив'яжіть номер телефону, щоб увійти або допомогти з відновленням облікового запису.",
        verification_title: 'Введіть код підтвердження SMS',
        verification_description: 'Код підтвердження надіслано на ваш телефон {{phone_number}}.',
        success: "Основний телефон успішно прив'язано.",
        verification_required: 'Термін перевірки минув. Підтвердіть свою особу ще раз.',
    },
    username: {
        title: "Встановити ім'я користувача",
        description: "Ім'я користувача може містити лише літери, цифри та символи підкреслення.",
        policy_description: '{{requirements}}',
        success: "Ім'я користувача успішно оновлено.",
    },
    security: {
        add: 'Додати',
        change: 'Змінити',
        remove: 'Видалити',
        not_set: 'Не встановлено',
        social_sign_in: 'Соціальний вхід',
        social_not_linked: 'Не прив’язано',
        email_phone: 'Електронна пошта / Телефон',
        email: 'Електронна пошта',
        phone: 'Телефон',
        password: 'Пароль',
        configured: 'Налаштовано',
        not_configured: 'Не налаштовано',
        two_step_verification: 'Двоетапна перевірка',
        authenticator_app: 'Додаток для автентифікації',
        passkeys: 'Passkeys',
        backup_codes: 'Резервні коди',
        email_verification_code: 'Код підтвердження електронної пошти',
        phone_verification_code: 'Код підтвердження телефону',
        passkeys_count_one: '{{count}} passkey',
        passkeys_count_other: '{{count}} passkeys',
        backup_codes_count_one: '{{count}} код залишився',
        backup_codes_count_other: '{{count}} кодів залишилось',
        view: 'Перегляд',
        manage: 'Керування',
        turn_on_2_step_verification_description: 'Додайте додатковий рівень безпеки. При вході вам буде запропоновано другий крок верифікації.',
        turn_off_2_step_verification: 'Вимкнути двоетапну верифікацію',
        turn_off_2_step_verification_description: 'Вимкнення двоетапної верифікації видалить додатковий рівень захисту вашого облікового запису при вході. Ви впевнені, що хочете продовжити?',
        disable_2_step_verification: 'Вимкнути',
        no_verification_method_warning: 'Ви не додали другий метод верифікації. Додайте принаймні один, щоб увімкнути двоетапну верифікацію при вході.',
        account_removal: 'Видалення акаунта',
        delete_your_account: 'Видаліть свій акаунт',
        delete_account: 'Видалити акаунт',
        remove_username_confirmation_title: "Видалити ім'я користувача",
        remove_username_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цього імені користувача. Ви впевнені, що хочете продовжити?',
        remove_email_confirmation_title: 'Видалити адресу електронної пошти',
        remove_email_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цієї адреси електронної пошти. Ви впевнені, що хочете продовжити?',
        remove_phone_confirmation_title: 'Видалити номер телефону',
        remove_phone_confirmation_description: 'Після видалення ви більше не зможете входити за допомогою цього номера телефону. Ви впевнені, що хочете продовжити?',
        email_removed: 'Адресу електронної пошти успішно видалено.',
        phone_removed: 'Номер телефону успішно видалено.',
        username_removed: "Ім'я користувача успішно видалено.",
    },
    social: {
        linked: '{{connector}} успішно прив’язано.',
        not_enabled: 'Цей спосіб входу через соціальну мережу не ввімкнено. Будь ласка, зверніться до адміністратора по допомогу.',
        removed: '{{connector}} успішно видалено.',
        remove_confirmation_title: 'Видалити соціальний акаунт',
        remove_confirmation_description: 'Якщо ви видалите {{connector}}, можливо, ви не зможете входити через нього, доки не додасте його знову.',
    },
    password: {
        title: 'Встановити пароль',
        description: 'Створіть новий пароль, щоб захистити свій обліковий запис.',
        success: 'Пароль успішно оновлено.',
    },
    code_verification: {
        send: 'Надіслати код підтвердження',
        resend: 'Ще не отримали? <a>Надіслати код підтвердження ще раз</a>',
        resend_countdown: 'Ще не отримали? Повторна відправка через {{seconds}} с.',
    },
    email_verification: {
        title: 'Підтвердьте свою електронну пошту',
        prepare_description: 'Підтвердіть, що це ви, щоб захистити безпеку облікового запису. Надішліть код підтвердження на свою електронну пошту.',
        email_label: 'Адреса електронної пошти',
        send: 'Надіслати код підтвердження',
        description: 'Код підтвердження надіслано на адресу {{email}}. Введіть код, щоб продовжити.',
        resend: 'Ще не отримали? <a>Надіслати код підтвердження ще раз</a>',
        not_received: 'Ще не отримали?',
        resend_action: 'Надіслати код підтвердження ще раз',
        resend_countdown: 'Ще не отримали? Повторна відправка через {{seconds}} с.',
        error_send_failed: 'Не вдалося надіслати код підтвердження. Спробуйте ще раз пізніше.',
        error_verify_failed: 'Не вдалося підтвердити. Будь ласка, введіть код ще раз.',
        error_invalid_code: 'Код підтвердження недійсний або строк його дії минув.',
    },
    phone_verification: {
        title: 'Підтвердьте свій телефон',
        prepare_description: 'Підтвердьте, що це ви, щоб захистити безпеку облікового запису. Надішліть код підтвердження на свій телефон.',
        phone_label: 'Номер телефону',
        send: 'Надіслати код підтвердження',
        description: 'Код підтвердження надіслано на ваш телефон {{phone}}. Введіть код, щоб продовжити.',
        resend: 'Ще не отримали? <a>Надіслати код підтвердження ще раз</a>',
        resend_countdown: 'Ще не отримали? Повторна відправка через {{seconds}} с.',
        error_send_failed: 'Не вдалося надіслати код підтвердження. Спробуйте ще раз пізніше.',
        error_verify_failed: 'Не вдалося підтвердити. Будь ласка, введіть код ще раз.',
        error_invalid_code: 'Код підтвердження недійсний або строк його дії минув.',
    },
    mfa: {
        totp_already_added: 'Ви вже додали додаток для автентифікації. Будь ласка, спочатку видаліть існуючий.',
        totp_not_enabled: 'Додаток для автентифікації OTP не увімкнено. Зверніться до адміністратора за допомогою.',
        backup_code_already_added: 'У вас вже є активні резервні коди. Будь ласка, використайте або видаліть їх перед створенням нових.',
        backup_code_not_enabled: 'Резервний код не увімкнено. Зверніться до адміністратора за допомогою.',
        backup_code_requires_other_mfa: 'Резервні коди вимагають попереднього налаштування іншого методу MFA.',
        passkey_not_enabled: 'Passkey не увімкнено. Зверніться до адміністратора за допомогою.',
        passkey_already_registered: 'Цей passkey вже зареєстровано у вашому обліковому записі. Будь ласка, використовуйте інший автентифікатор.',
    },
    update_success: {
        default: {
            title: 'Оновлено!',
            description: 'Вашу інформацію було оновлено.',
        },
        email: {
            title: 'Електронну пошту оновлено!',
            description: 'Вашу електронну адресу успішно оновлено.',
        },
        phone: {
            title: 'Номер телефону оновлено!',
            description: 'Ваш номер телефону успішно оновлено.',
        },
        username: {
            title: "Ім'я користувача змінено!",
            description: "Ваше ім'я користувача успішно оновлено.",
        },
        password: {
            title: 'Пароль змінено!',
            description: 'Ваш пароль успішно оновлено.',
        },
        totp: {
            title: 'Додаток для автентифікації додано!',
            description: "Ваш додаток для автентифікації успішно під'єднано до вашого акаунту.",
        },
        totp_replaced: {
            title: 'Додаток для автентифікації замінено!',
            description: 'Ваш додаток для автентифікації було успішно замінено.',
        },
        backup_code: {
            title: 'Резервні коди створено!',
            description: 'Ваші резервні коди збережено. Зберігайте їх у безпечному місці.',
        },
        passkey: {
            title: 'Passkey додано!',
            description: "Ваш passkey успішно під'єднано до вашого облікового запису.",
        },
        social: {
            title: "Соціальний акаунт під'єднано!",
            description: "Ваш соціальний акаунт успішно під'єднано.",
        },
    },
    backup_code: {
        title: 'Резервні коди',
        description: 'Ви можете використати один з цих резервних кодів для доступу до свого облікового запису, якщо у вас виникнуть проблеми під час двоетапної перевірки іншими способами. Кожен код можна використати лише один раз.',
        copy_hint: "Обов'язково скопіюйте їх і збережіть у надійному місці.",
        generate_new_title: 'Згенерувати нові резервні коди',
        generate_new: 'Згенерувати нові резервні коди',
    },
    passkey: {
        title: 'Passkeys',
        added: 'Додано: {{date}}',
        last_used: 'Останнє використання: {{date}}',
        never_used: 'Ніколи',
        unnamed: 'Passkey без назви',
        renamed: 'Passkey успішно перейменовано.',
        deleted: 'Passkey успішно видалено.',
        add_another_title: 'Додати інший passkey',
        add_another_description: 'Зареєструйте свій passkey за допомогою біометрії пристрою, ключів безпеки (наприклад, YubiKey) або інших доступних методів.',
        add_passkey: 'Додати passkey',
        delete_confirmation_title: 'Видалити ваш passkey',
        delete_confirmation_description: 'Якщо ви видалите цей passkey, ви не зможете використовувати його для підтвердження.',
        rename_passkey: 'Перейменувати passkey',
        rename_description: 'Введіть нову назву для цього passkey.',
        name_this_passkey: 'Назвіть цей passkey пристрою',
        name_passkey_description: 'Ви успішно підтвердили цей пристрій для двоетапної автентифікації. Налаштуйте назву для розпізнавання, якщо у вас кілька ключів.',
        name_input_label: "Ім'я",
    },
    sessions: {
        page_title: 'Сесії',
        page_description: 'Керуйте активними сесіями та авторизованими сторонніми додатками.',
        title: 'Сесії',
        current_session: 'Поточна сесія',
        signed_in_at: 'Вхід виконано {{date}}',
        revoke_session: 'Вийти',
        revoke_session_title: 'Завершити сесію',
        revoke_session_description: "Це завершить сесію та відкличе весь пов'язаний доступ. Ви впевнені, що хочете продовжити?",
        no_other_sessions: 'Немає інших активних сесій.',
        loading: 'Завантаження...',
        third_party_apps_title: 'Сторонні додатки',
        no_third_party_apps: 'Немає авторизованих сторонніх додатків.',
        third_party_apps_load_failed: 'Не вдалося завантажити сторонні додатки. Спробуйте ще раз.',
        granted_at: 'Авторизовано {{date}}',
        revoke_grant: 'Видалити',
        revoke_grant_title: 'Видалити доступ стороннього додатку',
        revoke_grant_description: 'Це відкличе весь доступ, наданий цьому додатку. Ви впевнені, що хочете продовжити?',
        revoke_grant_failed: 'Не вдалося відкликати деякі дозволи. Будь ласка, спробуйте ще раз.',
    },
};
export default Object.freeze(account_center);
